import { render } from "./defaultCurrencyRequired.vue?vue&type=template&id=31f1eedb"
import script from "./defaultCurrencyRequired.vue?vue&type=script&lang=js"
export * from "./defaultCurrencyRequired.vue?vue&type=script&lang=js"

import "./defaultCurrencyRequired.vue?vue&type=style&index=0&id=31f1eedb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__